import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {Location} from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import * as moment from 'moment';

@Component({
  selector: 'app-me-fichatreino',
  templateUrl: './me-fichatreino.component.html',
  styleUrls: ['./me-fichatreino.component.css']
})
export class MeFichatreinoComponent implements OnInit {
  existeTreino: boolean = false;
  hideCL: boolean = false;
  idFicha: any = 0;
  arrDiasTreino: any[] = [];
  nomePro: any = '';
  nomeTreino: any = '';
  dataFicha: any = '';
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService) { }

  ngOnInit() {
    
    this.existeTreino = true;
    this.montarListaTreino();
  }
  voltar(): void{
    if(this.tmaService.paginaAnterior == 'home'){
      this.router.navigate(['/home']);
    }
    else{
      this.router.navigate(['me/treinos']);
    }
    //this._location.back();
}

  montarListaTreino() :void{
    this.hideCL = false;
    const id = +this.route.snapshot.paramMap.get('idficha');
    this.idFicha = id;
    var gDados = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idficha=' + this.idFicha;
    this.tmaService.listarDiasTreino(gDados)
    .subscribe((qRes) =>{
      console.log(qRes);
      this.hideCL = true;
      if(qRes['res'] == 'done'){
        this.nomePro = qRes['profissional']
        this.arrDiasTreino = qRes['arrFTreinos'];
        this.nomeTreino = qRes['dadosFicha'].nomeplano;
        this.dataFicha = moment(qRes['dadosFicha'].data).format('DD/MM/YYYY');

        var arrTreinosD = [];
        arrTreinosD = qRes['arrTreinosDone'];
        this.arrDiasTreino .forEach((item, index) => {
          if(arrTreinosD.find(x => x.idTreino == item.Id)){
            this.arrDiasTreino[index].dataultimo = arrTreinosD.find(x => x.idTreino == item.Id).dataUlt;
          }
          else{
            this.arrDiasTreino[index].dataultimo = "nothing";
          }
        });
        if(this.arrDiasTreino.length > 0){
          this.existeTreino = true;
        }
        else{
          this.existeTreino = false;
        }
      }
    })

  }
  goTreino(idTreino: any) :void{
    this.router.navigate(['me/treino/' + this.idFicha + "/" + idTreino]);
  }
}
